import { c as _c } from "react/compiler-runtime";
const SectionHead = t0 => {
  const $ = _c(7);
  const {
    headline,
    subline
  } = t0;
  let t1;
  if ($[0] !== headline) {
    t1 = <h2 className="text-d3 font-book tracking-tight m-none">{headline}</h2>;
    $[0] = headline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subline) {
    t2 = subline && <p className="text-body-1 font-book text-neutral-425 mt-3s max-w-[64ch]">{subline}</p>;
    $[2] = subline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default SectionHead;